.marketing-header {
    font-weight: 500;
    color: var(--grey-dk);
    font-size: var(--font-huge);
    line-height: 1.5;
    margin-bottom: 12px;
}
